import { EStarSize, Stars } from '@cian/frontend-reviews-components';
import { IconToggleFavoriteOn12, UIHeading5 } from '@cian/ui-kit';

import * as styles from './RatingInsideAuthor.css';

interface IRatingInsideAuthorProps {
  rating?: number;
  showFullStars?: boolean;
}

const editDecimalPart = (num: number) => {
  if (num % 1 === 0) {
    return num + ',0'; // если целое, добавляем дробную часть
  } else {
    return String(num).replace('.', ','); // иначе меняем десятичный разделитель
  }
};

export const RatingInsideAuthor = ({ rating, showFullStars }: IRatingInsideAuthorProps) => {
  if (!rating) {
    return null;
  }

  if (showFullStars) {
    return (
      <div className={styles['stars']}>
        <Stars size={EStarSize.M} value={rating} />
      </div>
    );
  }

  return (
    <div className={styles['stars']}>
      {showFullStars ? (
        <Stars size={EStarSize.M} value={rating} />
      ) : (
        <>
          <IconToggleFavoriteOn12 color="warning_100" />
          <UIHeading5 color="warning_100">{editDecimalPart(rating)}</UIHeading5>
        </>
      )}
    </div>
  );
};
